import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment, HttpHeadersService } from '@perval/shared';
import { firstValueFrom, map } from 'rxjs';
import { Organisme } from '../models/organisme';
import {
  fromOrganismeBillingHttpToOrganisme,
  OrganismeBillingHttp,
} from './mappers/organisme.mapper';

@Injectable({
  providedIn: 'root',
})
// TODO : Homogénéiser les routes après la petite refacto de https://adnov.atlassian.net/browse/NPER-885
export class OrganismeService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-utilisateurs/organizations`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  public async getOrganismeBilling(): Promise<Organisme> {
    return firstValueFrom(
      this.http
        .get<OrganismeBillingHttp>(
          `${environment.baseApiUrl}/perval-utilisateurs/organizations/billing`,
          {
            headers:
              await this.httpHeadersServiceService.getHeadersWithPervalContext(),
          },
        )
        .pipe(map(fromOrganismeBillingHttpToOrganisme)),
    );
  }

  public async synchroOrganisme(): Promise<void> {
    const headers =
      await this.httpHeadersServiceService.getHeadersWithPervalContext();

    firstValueFrom(
      this.http.post(
        `${environment.baseApiUrl}/perval-utilisateurs/organizations/synchro`,
        null,
        {
          headers,
        },
      ),
    );
  }
}
